import { chakra } from '@chakra-ui/react'

export const Wrapper = chakra('div', {
    baseStyle: ({ theme }) => ({
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.transcript.textColors[theme.textColorIndex].colorValue,
    }),
})
